import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import Navbar from "../components/Navbar";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success(`Welcome back, ${u.full_name.split(" ")[0]}`);
      nav(u.role === "admin" ? "/admin" : u.role === "employee" ? "/employee" : "/customer");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FE]">
      <Navbar />
      <div className="max-w-md mx-auto px-6 py-20">
        <div className="label-eyebrow mb-3">Welcome back</div>
        <h1 className="font-display text-4xl font-bold tracking-tight">Sign in to KSB</h1>
        <p className="text-[#5B6478] mt-2">Continue building your trusted household team.</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <Label htmlFor="email" className="label-eyebrow">Email</Label>
            <Input
              id="email"
              data-testid="login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 border-[#E4E7F5] focus:ring-[#1E3A8A]"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <Label htmlFor="password" className="label-eyebrow">Password</Label>
            <Input
              id="password"
              data-testid="login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-12 border-[#E4E7F5] focus:ring-[#1E3A8A]"
              placeholder="••••••••"
            />
          </div>
          <Button
            type="submit"
            data-testid="login-submit"
            disabled={busy}
            className="w-full h-12 bg-[#1E3A8A] hover:bg-[#2E4FB8] text-[#F8F9FE]"
          >
            {busy ? "Signing in..." : "Sign in"}
          </Button>
        </form>

        <div className="text-sm text-[#5B6478] mt-6 text-center">
          Don't have an account?{" "}
          <Link to="/signup" className="font-semibold text-[#1E3A8A] hover:underline">Create one</Link>
        </div>

        <div className="mt-10 bg-[#EEF0FA] border border-[#E4E7F5] rounded-md p-4 text-xs text-[#5B6478]">
          <div className="font-bold mb-1">Test accounts:</div>
          <div>Admin: admin@keritexstaffing.co.ke / admin123</div>
          <div>Sample staff: grace.wanjiku@keritexstaffing.co.ke / password123</div>
        </div>
      </div>
    </div>
  );
}
